import Typography from '@/common/components/base/typography/Typography';
import { Box } from 'styled-system/jsx';
import { SortOptionModalType } from '@/modules/FileList/components/listFilterSection/advanceFilter/components/SortModal/SortModal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { css } from 'styled-system/css';
const SortModal = ({ options, onClick }: SortOptionModalType) => {
  return (
    <Box
      display="flex"
      gap="1rem"
      alignItems="stretch"
      flexDirection="column"
      flexWrap="wrap"
      my="3rem"
      justifyContent="space-between"
    >
      <TitleDescription
        className={css({
          display: 'flex',
          flexDirection: 'row',
          gap: '2px',
        })}
        textStyle="h2"
        color="black-1"
      >
        مرتب سازی{' '}
        <Typography textStyle="h2" color="black-4">
          (براساس تاریخ دریافت پرونده)
        </Typography>
      </TitleDescription>
      {options.map((item, index) => {
        return (
          <>
            <Box
              onClick={() => {
                onClick(item);
              }}
              key={`${item.value}`}
            >
              <Box display="flex" justifyContent="space-between">
                <Typography
                  cursor="pointer"
                  textAlign="center"
                  minWidth="12px"
                  color="black-1"
                  textStyle="b2"
                >
                  {item.label}
                </Typography>
              </Box>
            </Box>
            {index !== options.length - 1 && (
              <Box
                display="flex"
                paddingX={'1rem'}
                alignItems="center"
                gap="5px"
              >
                <Box borderBottom="1px solid {colors.gray-1}" width="100%" />
              </Box>
            )}
          </>
        );
      })}
    </Box>
  );
};

export default SortModal;
